/**
 * @generated SignedSource<<854d60a2833cfbdcdeff97455744caa3>>
 * @relayHash b90cd53f70567d4b8f720cb2a57b78cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6e35a8e4ce3cf38f251571556d35d72800945a4dbc2ebeae696aa7d798b02dd8

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentStudioAgentQueryInput = {
  includeDraftAgents?: boolean | null;
  includeJiraCodingAgent?: boolean | null;
  name?: string | null;
  onlyEditableAgents?: boolean | null;
  onlyFavouriteAgents?: boolean | null;
  onlyMyAgents?: boolean | null;
  onlyPublishedEditableAgents?: boolean | null;
  onlyPublishedEditableAgentsWithForge?: boolean | null;
  onlyTemplateAgents?: boolean | null;
  onlyUnpublishedAgents?: boolean | null;
  onlyVerifiedAgents?: boolean | null;
};
export type browseAgentsContentPaginationQuery$variables = {
  after?: string | null;
  cloudId: string;
  cloudIdAsId: string;
  enableJiraAgentFields: boolean;
  first?: number | null;
  input?: AgentStudioAgentQueryInput | null;
  product?: string | null;
  workspaceId?: string | null;
};
export type browseAgentsContentPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"browseAgentsContent_AtlassianConversationAssistantAgent">;
};
export type browseAgentsContentPaginationQuery = {
  response: browseAgentsContentPaginationQuery$data;
  variables: browseAgentsContentPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIdAsId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "enableJiraAgentFields"
  },
  {
    "defaultValue": 30,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "product"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v4 = {
  "kind": "Variable",
  "name": "input",
  "variableName": "input"
},
v5 = {
  "kind": "Variable",
  "name": "product",
  "variableName": "product"
},
v6 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v7 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "browseAgentsContentPaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "cloudIdAsId",
            "variableName": "cloudIdAsId"
          },
          {
            "kind": "Variable",
            "name": "enableJiraAgentFields",
            "variableName": "enableJiraAgentFields"
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "browseAgentsContent_AtlassianConversationAssistantAgent"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "browseAgentsContentPaginationQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "AgentStudioAgentsConnection",
        "kind": "LinkedField",
        "name": "agentStudio_getAgents",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAssistant",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "deactivated"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "creatorType"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "conversationStarters"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "identityAccountId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "externalConfigReference"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "creator",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "icon"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "authoringTeam",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "profileUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "forgeCreator"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isVerified"
                  },
                  {
                    "condition": "enableJiraAgentFields",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "concreteType": "AgentStudioAgentPermissions",
                        "kind": "LinkedField",
                        "name": "permissions",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canEdit"
                          }
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudIdAsId"
                          }
                        ],
                        "concreteType": "JiraAgentAssignability",
                        "kind": "LinkedField",
                        "name": "jiraAssignability",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "isAssignable"
                          }
                        ]
                      }
                    ]
                  },
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v7/*: any*/),
        "filters": [
          "cloudId",
          "input",
          "product",
          "workspaceId"
        ],
        "handle": "connection",
        "key": "paginatedAgentsList_agentStudio_getAgents",
        "kind": "LinkedHandle",
        "name": "agentStudio_getAgents"
      }
    ]
  },
  "params": {
    "id": "6e35a8e4ce3cf38f251571556d35d72800945a4dbc2ebeae696aa7d798b02dd8",
    "metadata": {},
    "name": "browseAgentsContentPaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c5e254522d2af957a047b80663b0633e";

export default node;
